import classnames from 'classnames';
import React from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'components/ui/base';

import * as styles from '../MediaGallery.module.less';

export type DeleteProps = {
  disabled?: boolean;
  onDelete: () => void;
  tooltipTitle?: MessageDescriptor;
};

const Delete: React.FC<DeleteProps> = ({ disabled = false, onDelete, tooltipTitle = { id: 'delete', defaultMessage: 'Delete' } }) => (
  <Tooltip title={<FormattedMessage {...tooltipTitle} />}>
    <i
      data-cy="delete"
      className={classnames(styles['media-actions__icon'], styles['media-actions__delete'], 'fb-icon--delete', {
        [styles['icon-disabled']]: disabled
      })}
      onClick={!disabled ? onDelete : undefined}
    />
  </Tooltip>
);

export default Delete;
